// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../basic-material-dialog/basic-material-dialog.directive";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";

export interface DialogData_SettingsDialog extends MatDialogDataBaseInput {
	route: string;
}

export interface DialogData_SettingsDialogOutput {
	action: "ok" | "close";
}

@Component({
	selector: "sim-settings-dialog",
	templateUrl: "./settings-dialog.component.html",
	styleUrls: ["./settings-dialog.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	standalone: false,
})
export class SettingsDialogComponent extends BasicMaterialDialog<
	SettingsDialogComponent,
	DialogData_SettingsDialog,
	DialogData_SettingsDialogOutput
> {
	public breakpointObserver: BreakpointObserver;
	public settingPages = [
		/*{
			title: "General Settings",
			icon: "fad fa-cog",
			active: true,
			subCategoriesOpen: false,
			subCategories: []
		},
		{
			title: "Recording Settings",
			icon: "fad fa-video",
			active: false,
			subCategoriesOpen: false,
			subCategories: []
		},
		{
			title: "User Settings",
			icon: "fad fa-user",
			active: false,
			subCategoriesOpen: false,
			subCategories: []
		},*/
		{
			title: "Dashboard Configuration",
			icon: "fad fa-columns",
			active: false,
			subCategoriesOpen: false,
			subCategories: [],
		},
	];

	activeSettingsPage: number = 0;
	activeSettingsPageSub: number = -1;
	public mobileNav: boolean = false;
	mobileNavOpen: boolean = false;

	constructor(_injector: Injector) {
		super(_injector);
		this.init();

		this.observer.observe(["(min-width: 992px)"]).subscribe((state: BreakpointState) => {
			this.mobileNav = !state.matches;
		});
	}

	private init() {
		if (this.data.route.includes("simrecorder/default")) {
			this.activeSettingsPage = 1;
		} else if (this.data.route.includes("stage-designer")) {
			this.activeSettingsPage = 4;
		} else {
			this.activeSettingsPage = 0;
		}
	}

	setActiveSettingsPage(i1: number) {
		if (this.activeSettingsPage !== i1) {
			this.activeSettingsPageSub = -1;
			this.activeSettingsPage = i1;
		} else {
			this.activeSettingsPage = i1;
		}

		if (this.settingPages[i1].subCategories?.length) {
			this.settingPages[i1].subCategoriesOpen = true;
		}
	}
}
